exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".root-default-page[data-v-53af4b25]{display:flex;justify-content:center;overflow:hidden}.root-default-page .default-page[data-v-53af4b25]{min-height:100vh;width:100%}", ""]);

// exports
